// Module
var code = "<ui-v2-embed id=\"oss-licenses\" src=\"/v2/embed/oss-licenses\"></ui-v2-embed> ";
// Exports
export default code;